import { createContext } from "react";

const TourContext = createContext({ key: '', steps: [], options: {}, isOpen: false, setTour: () => { } });

export default TourContext;